import React, { useState } from 'react'
import CashFlowTable from './components/CashFlowTable'
import Header from './components/Header'
import { CashFlowContext } from './context'

function CashFlow() {
    const [displaySingleCashFlow, setDisplaySingleCashFlow] = useState(true)
    const [singleCashFlowData, setSingleCashFlowData] = useState(true)

    return (
        <CashFlowContext.Provider value={{ displaySingleCashFlow, setDisplaySingleCashFlow, singleCashFlowData, setSingleCashFlowData }}>
            <Header />
            <CashFlowTable />
        </CashFlowContext.Provider>
    )
}

export default CashFlow
